import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { SUPPLIER_PATH } from '../../../../config/paths';

const SupplierToolbar = ({ supplierId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${SUPPLIER_PATH}/${supplierId}/edit`} />{' '}
    </div>
  </ButtonToolbar>
);

SupplierToolbar.propTypes = {
  supplierId: PropTypes.number.isRequired,
};

export default SupplierToolbar;
